// Client Actions
export const FETCH_CLIENTS_REQUEST = 'FETCH_CLIENTS_REQUEST';
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS';
export const FETCH_CLIENTS_FAILURE = 'FETCH_CLIENTS_FAILURE';

export const FETCH_CLIENT_BY_ID_REQUEST = 'FETCH_CLIENT_BY_ID_REQUEST';
export const FETCH_CLIENT_BY_ID_SUCCESS = 'FETCH_CLIENT_BY_ID_SUCCESS';
export const FETCH_CLIENT_BY_ID_FAILURE = 'FETCH_CLIENT_BY_ID_FAILURE';

export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST';
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS';
export const CREATE_CLIENT_FAILURE = 'CREATE_CLIENT_FAILURE';

export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';
export const UPDATE_CLIENT_FAILURE = 'UPDATE_CLIENT_FAILURE';

export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST';
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS';
export const DELETE_CLIENT_FAILURE = 'DELETE_CLIENT_FAILURE';

// Action Creators
export const fetchClientsRequest = (params = {}) => ({
    type: FETCH_CLIENTS_REQUEST,
    payload: params,
});

export const fetchClientsSuccess = (data) => ({
    type: FETCH_CLIENTS_SUCCESS,
    payload: data,
});

export const fetchClientsFailure = (error) => ({
    type: FETCH_CLIENTS_FAILURE,
    payload: error,
});

export const fetchClientByIdRequest = (clientId) => ({
    type: FETCH_CLIENT_BY_ID_REQUEST,
    payload: clientId,
});

export const fetchClientByIdSuccess = (data) => ({
    type: FETCH_CLIENT_BY_ID_SUCCESS,
    payload: data,
});

export const fetchClientByIdFailure = (error) => ({
    type: FETCH_CLIENT_BY_ID_FAILURE,
    payload: error,
});

export const createClientRequest = (clientData) => ({
    type: CREATE_CLIENT_REQUEST,
    payload: clientData,
});

export const createClientSuccess = (data) => ({
    type: CREATE_CLIENT_SUCCESS,
    payload: data,
});

export const createClientFailure = (error) => ({
    type: CREATE_CLIENT_FAILURE,
    payload: error,
});

export const updateClientRequest = (clientId, clientData) => ({
    type: UPDATE_CLIENT_REQUEST,
    payload: { clientId, clientData },
});

export const updateClientSuccess = (data) => ({
    type: UPDATE_CLIENT_SUCCESS,
    payload: data,
});

export const updateClientFailure = (error) => ({
    type: UPDATE_CLIENT_FAILURE,
    payload: error,
});

export const deleteClientRequest = (clientId) => ({
    type: DELETE_CLIENT_REQUEST,
    payload: clientId,
});

export const deleteClientSuccess = (clientId) => ({
    type: DELETE_CLIENT_SUCCESS,
    payload: clientId,
});

export const deleteClientFailure = (error) => ({
    type: DELETE_CLIENT_FAILURE,
    payload: error,
});



